<template>
    <div class="col-md-3" style="position:static;">
        <div class="sidebarleftmain">
            <nav class="navbar custom-navbar">
                <div class="navbar-header">
                    <button class="navbar-toggle" type="button" @click="isMenuOpen = !isMenuOpen">
                        <span class="sr-only">Toggle navigation</span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                    </button>
                </div>
                <!-- Debug log for categories -->
                <!-- <div style="color: red; font-size: 12px;">{{ categoriesWithSlugs }}</div> -->
                <div :class="['collapse', 'navbar-collapse', 'js-navbar-collapse', { show: isMenuOpen }]">
                    <ul class="nav navbar-nav custom-nav">
                        <li
                            v-for="category in categoriesWithSlugs"
                            :key="category.id"
                            class="dropdown mega-dropdown nav-item"
                        >
                            <router-link :to="`/category/${category.slug}`" class="dropdown-toggle nav-link">
                                <div class="nav-icon-wrapper">
                                    <img
                                        :src="category.image || '/placeholder-logo.png'"
                                        :alt="category.name"
                                        style="width: 45px; height: 45px; object-fit: contain;"
                                    />
                                </div>
                                <span class="nav-text">{{ category.name }}</span>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </nav>
            <br>
        </div>
    </div>
</template>
<script setup>
import { ref, onMounted, computed } from 'vue'
import '../assets/styles/theme.css'

const isMenuOpen = ref(false)
const categories = ref([])

// Function to convert category name to slug
const categoryNameToSlug = (categoryName) => {
  if (!categoryName) return 'unknown'
  return categoryName.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '').replace(/&/g, '')
}

// Computed property to add slugs to categories
const categoriesWithSlugs = computed(() => {
  return categories.value.map(category => {
    const slug = category.slug || categoryNameToSlug(category.name)
    
    return {
      ...category,
      slug: slug
    }
  })
})

onMounted(async () => {
    try {
        const response = await fetch('https://franchisebrigade.com/admin/api/categories', {
            headers: {
                'Accept': 'application/json'
            },
            mode: 'cors',
            credentials: 'omit'
        })
        if (!response.ok) {
            throw new Error('Failed to fetch categories')
        }
        const data = await response.json()
  
        
        // Filter only active categories and transform the data
        categories.value = data
            .filter(category => category.is_active === 1)
            .map(category => ({
                id: category.id,
                name: category.name,
                slug: category.slug,
                description: category.description,
                image: category.image,
                is_active: category.is_active
            }))
    } catch (error) {
        // Fallback to default categories if API fails
        categories.value = [
            { id: 1, name: 'Food & Beverage', slug: 'food-beverage', image: '/placeholder-logo.png' },
            { id: 2, name: 'Retail', slug: 'retail', image: '/placeholder-logo.png' },
            { id: 3, name: 'Services', slug: 'services', image: '/placeholder-logo.png' },
            { id: 4, name: 'Education', slug: 'education', image: '/placeholder-logo.png' },
            { id: 5, name: 'Health & Wellness', slug: 'health-wellness', image: '/placeholder-logo.png' }
        ]
    }
})
</script>
<style scoped>
.custom-navbar {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 15px rgba(0,0,0,0.1);
    border: 1px solid #e5e5e5;
    margin-bottom: 20px;
}

/* Force menu to show for debugging */
.collapse, .collapse.show {
  display: block !important;
  opacity: 1 !important;
  visibility: visible !important;
  background: #fff !important;
}

.custom-nav {
    width: 100%;
    margin: 0;
    padding: 0;
}

.nav-item {
    border-bottom: 1px solid #f0f0f0;
    transition: all 0.3s ease;
    position: relative;
}

.nav-item:last-child {
    border-bottom: none;
}

.nav-item:hover {
    /* Remove background and translateX on hover */
    background: transparent;
    transform: none;
}

.nav-link {
    display: flex;
    align-items: center;
    padding: 15px 20px;
    color: var(--primary-blue);
    text-decoration: none;
    transition: all 0.3s ease;
    font-weight: 500;
    font-size: 14px;
    position: relative;
    overflow: hidden;
    background: transparent;
}

.nav-link:hover {
    color: var(--primary-orange);
    text-decoration: none;
    background: transparent;
}

.nav-link:hover .nav-icon-wrapper {
    background: rgba(255, 255, 255, 0.2);
    transform: scale(1.1);
}

.nav-link:hover .nav-text {
    color: var(--primary-orange);
}

.nav-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background: #f8f9fa;
    border-radius: 8px;
    margin-right: 15px;
    transition: all 0.3s ease;
    position: relative;
}

.nav-icon-wrapper i {
    font-size: 18px;
    color: var(--primary-orange);
    transition: all 0.3s ease;
}

.nav-item:hover .nav-icon-wrapper i {
    color: var(--primary-orange);
}

.nav-text {
    flex: 1;
    font-weight: 500;
    transition: all 0.3s ease;
}

/* Animation for icon */
.nav-icon-wrapper::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
    transition: left 0.5s;
}

.nav-item:hover .nav-icon-wrapper::before {
    left: 100%;
}

/* Responsive design */
@media (max-width: 768px) {
    .nav-link {
        padding: 12px 15px;
        font-size: 13px;
    }
    
    .nav-icon-wrapper {
        width: 35px;
        height: 35px;
        margin-right: 12px;
    }
    
    .nav-icon-wrapper i {
        font-size: 16px;
    }
}

/* Custom scrollbar for long lists */
.custom-navbar {
    max-height: 500px;
    overflow-y: auto;
}

.custom-navbar::-webkit-scrollbar {
    width: 6px;
}

.custom-navbar::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
}

.custom-navbar::-webkit-scrollbar-thumb {
    background: var(--primary-orange);
    border-radius: 3px;
}

.custom-navbar::-webkit-scrollbar-thumb:hover {
    background: var(--primary-blue);
}

/* Active state */
.nav-item.active {
    background: linear-gradient(135deg, var(--primary-blue) 0%, var(--primary-orange) 100%);
}

.nav-item.active .nav-link {
    color: #fff;
}

.nav-item.active .nav-icon-wrapper {
    background: rgba(255, 255, 255, 0.2);
}

.nav-item.active .nav-icon-wrapper i {
    color: #fff;
}

/* Remove arrow on hover */
.nav-item::after {
    display: none;
}

@media (max-width: 768px) {
  .col-md-3,
  .sidebarleftmain {
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    border-radius: 0 !important;
  }
  .custom-navbar {
    border-radius: 0 !important;
    margin-bottom: 0 !important;
  }
}
</style>